import { memo } from "react";
import { classNames } from "helpers";
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";

const OfferItemsAddedChild: React.FC<TableRowChildProps> = (props) => {
  const { index, row } = props;

  return (
    <>
      <tr
        key={index}
        className={classNames(
          `bg-amber-50 hover:bg-slate-100 relative text-slate-900` // Animacija sa delay-om
        )}
      >
        <td className="text-sm text-center w-full" colSpan={12}>
          <div className="flex items-center p-3">{row.note}</div>
        </td>
      </tr>
    </>
  );
};

export default memo(OfferItemsAddedChild);
